import type { SVGProps } from "react";
import { memo } from "react";
const NICEEnginFrame = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M21.919 44.879C24.393 51.436 31.629 56 40 56c10.477 0 19-7.178 19-16 0-8.823-8.523-16-19-16-8.372 0-15.607 4.563-18.082 11.12Q22.45 35 23 35h22c2.757 0 5 2.243 5 5 0 2.756-2.243 5-5 5H23q-.55 0-1.081-.121M40 58c-10.195 0-18.883-6.244-20.658-14.847a1 1 0 0 1 1.652-.942c.56.509 1.272.789 2.006.789h22c1.654 0 3-1.346 3-3 0-1.655-1.346-3-3-3H23c-.734 0-1.446.279-2.007.788a1 1 0 0 1-1.651-.943C21.117 28.243 29.805 22 40 22c11.579 0 21 8.074 21 18s-9.421 18-21 18m0-40c-14.337 0-26 9.869-26 22s11.663 22 26 22 26-9.87 26-22-11.663-22-26-22m0 46c-15.439 0-28-10.767-28-24s12.561-24 28-24 28 10.766 28 24-12.56 24-28 24"
      />
    </g>
  </svg>
);
const Memo = memo(NICEEnginFrame);
export default Memo;
